(function (globalScope) {
  'use strict';

  function deriveOfferState(qualifyingQuantity, discountApplied) {
    const quantity = Math.max(0, Number(qualifyingQuantity) || 0);
    const remaining = Math.max(0, 4 - quantity);

    if (discountApplied) return { name: 'applied', remaining: 0 };
    if (quantity === 0) return { name: 'hidden', remaining };
    if (quantity < 4) return { name: 'progress', remaining };
    if (quantity === 4) return { name: 'unlocked', remaining: 0 };
    return { name: 'unavailable', remaining: 0 };
  }

  async function addReward({
    variantId,
    cartDrawer,
    cartAddUrl,
    sectionsUrl,
    fetchImpl,
  }) {
    const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
    const response = await fetchImpl(cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections,
        sections_url: sectionsUrl,
      }),
    });
    const state = await response.json();

    if (!response.ok || state.status) {
      throw new Error(state.description || state.message || 'Unable to add the free product.');
    }

    cartDrawer.renderContents(state);
    return state;
  }

  function selectedVariantId(button) {
    const product = button.closest('[data-bundle-product]');
    const selector = product && product.querySelector('[data-bundle-variant]');
    return selector ? selector.value : button.dataset.variantId;
  }

  const api = { addReward, deriveOfferState, selectedVariantId };

  if (
    globalScope &&
    globalScope.customElements &&
    globalScope.HTMLElement &&
    !globalScope.customElements.get('cart-bundle-offer')
  ) {
    class CartBundleOffer extends globalScope.HTMLElement {
      connectedCallback() {
        if (this.dataset.state !== 'unlocked' || this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.addEventListener('click', this.onClick.bind(this));
      }

      async onClick(event) {
        const button = event.target.closest('[data-bundle-add]');
        if (!button || !this.contains(button) || this.dataset.busy === 'true') return;

        const cartDrawer = this.closest('cart-drawer') || globalScope.document.querySelector('cart-drawer');
        if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
          this.showError('The cart could not be updated. Please refresh the page and try again.');
          return;
        }

        const variantId = selectedVariantId(button);
        if (!variantId) {
          this.showError('Please choose an available product option.');
          return;
        }

        this.setBusy(true, button);
        this.showError('');
        if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(button);

        try {
          await addReward({
            variantId,
            cartDrawer,
            cartAddUrl: globalScope.routes?.cart_add_url || '/cart/add.js',
            sectionsUrl: globalScope.location.pathname,
            fetchImpl: globalScope.fetch.bind(globalScope),
          });

          globalScope.fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
              globalScope.document.dispatchEvent(
                new globalScope.CustomEvent('cart:changed', {
                  bubbles: false,
                  detail: { cartobject: cart },
                })
              );
            })
            .catch(() => {});
        } catch (error) {
          this.showError(error.message || 'Unable to add the free product. Please try again.');
          this.setBusy(false, button);
        }
      }

      setBusy(isBusy, activeButton) {
        this.dataset.busy = String(isBusy);
        this.querySelectorAll('[data-bundle-add]').forEach((button) => {
          button.disabled = isBusy;
          button.setAttribute('aria-busy', String(isBusy && button === activeButton));
        });
      }

      showError(message) {
        const error = this.querySelector('[data-bundle-error]');
        if (!error) return;

        error.textContent = message;
        error.hidden = !message;
      }
    }

    globalScope.customElements.define('cart-bundle-offer', CartBundleOffer);
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (globalScope) globalScope.CartBundleOfferHelpers = api;
})(typeof window !== 'undefined' ? window : globalThis);
